import { SWITCH_LOCATION } from "./actionType";

const switchLocation = location => {
  return (dispatch, getState) => {
    const { currentActive } = getState().location;
    if (currentActive !== location) {
      dispatch({
        type: SWITCH_LOCATION,
        location
      });
    }
  };
};

export { switchLocation };



// WEBPACK FOOTER //
// ./src/actions/location.js